<template>
  <add-a-photo v-if="valueName == 'add_a_photo'" />
  <add-photo-alternate v-else-if="valueName == 'add_photo_alternate'" />
  <add-to-photos v-else-if="valueName == 'add_to_photos'" />
  <adjust v-else-if="valueName == 'adjust'" />
  <assistant v-else-if="valueName == 'assistant'" />
  <assistant-photo v-else-if="valueName == 'assistant_photo'" />
  <audiotrack v-else-if="valueName == 'audiotrack'" />
  <bedtime v-else-if="valueName == 'bedtime'" />
  <blur-circular v-else-if="valueName == 'blur_circular'" />
  <blur-linear v-else-if="valueName == 'blur_linear'" />
  <blur-off v-else-if="valueName == 'blur_off'" />
  <blur-on v-else-if="valueName == 'blur_on'" />
  <brightness-1 v-else-if="valueName == 'brightness_1'" />
  <brightness-2 v-else-if="valueName == 'brightness_2'" />
  <brightness-3 v-else-if="valueName == 'brightness_3'" />
  <brightness-4 v-else-if="valueName == 'brightness_4'" />
  <brightness-5 v-else-if="valueName == 'brightness_5'" />
  <brightness-6 v-else-if="valueName == 'brightness_6'" />
  <brightness-7 v-else-if="valueName == 'brightness_7'" />
  <broken-image v-else-if="valueName == 'broken_image'" />
  <brush v-else-if="valueName == 'brush'" />
  <burst-mode v-else-if="valueName == 'burst_mode'" />
  <camera v-else-if="valueName == 'camera'" />
  <camera-alt v-else-if="valueName == 'camera_alt'" />
  <camera-front v-else-if="valueName == 'camera_front'" />
  <camera-rear v-else-if="valueName == 'camera_rear'" />
  <camera-roll v-else-if="valueName == 'camera_roll'" />
  <center-focus-strong v-else-if="valueName == 'center_focus_strong'" />
  <center-focus-weak v-else-if="valueName == 'center_focus_weak'" />
  <collections v-else-if="valueName == 'collections'" />
  <collections-bookmark v-else-if="valueName == 'collections_bookmark'" />
  <color-lens v-else-if="valueName == 'color_lens'" />
  <colorize v-else-if="valueName == 'colorize'" />
  <compare v-else-if="valueName == 'compare'" />
  <control-point v-else-if="valueName == 'control_point'" />
  <control-point-duplicate v-else-if="valueName == 'control_point_duplicate'" />
  <crop v-else-if="valueName == 'crop'" />
  <crop-3-2 v-else-if="valueName == 'crop_3_2'" />
  <crop-5-4 v-else-if="valueName == 'crop_5_4'" />
  <crop-7-5 v-else-if="valueName == 'crop_7_5'" />
  <crop-16-9 v-else-if="valueName == 'crop_16_9'" />
  <crop-din v-else-if="valueName == 'crop_din'" />
  <crop-free v-else-if="valueName == 'crop_free'" />
  <crop-landscape v-else-if="valueName == 'crop_landscape'" />
  <crop-original v-else-if="valueName == 'crop_original'" />
  <crop-portrait v-else-if="valueName == 'crop_portrait'" />
  <crop-rotate v-else-if="valueName == 'crop_rotate'" />
  <crop-square v-else-if="valueName == 'crop_square'" />
  <dehaze v-else-if="valueName == 'dehaze'" />
  <ic-details v-else-if="valueName == 'details'" />
  <edit v-else-if="valueName == 'edit'" />
  <euro v-else-if="valueName == 'euro'" />
  <exposure v-else-if="valueName == 'exposure'" />
  <exposure-neg-1 v-else-if="valueName == 'exposure_neg_1'" />
  <exposure-neg-2 v-else-if="valueName == 'exposure_neg_2'" />
  <exposure-plus-1 v-else-if="valueName == 'exposure_plus_1'" />
  <exposure-plus-2 v-else-if="valueName == 'exposure_plus_2'" />
  <exposure-zero v-else-if="valueName == 'exposure_zero'" />
  <ic-filter v-else-if="valueName == 'filter'" />
  <filter-1 v-else-if="valueName == 'filter_1'" />
  <filter-2 v-else-if="valueName == 'filter_2'" />
  <filter-3 v-else-if="valueName == 'filter_3'" />
  <filter-4 v-else-if="valueName == 'filter_4'" />
  <filter-5 v-else-if="valueName == 'filter_5'" />
  <filter-6 v-else-if="valueName == 'filter_6'" />
  <filter-7 v-else-if="valueName == 'filter_7'" />
  <filter-8 v-else-if="valueName == 'filter_8'" />
  <filter-9 v-else-if="valueName == 'filter_9'" />
  <filter-9-plus v-else-if="valueName == 'filter_9_plus'" />
  <filter-b-and-w v-else-if="valueName == 'filter_b_and_w'" />
  <filter-center-focus v-else-if="valueName == 'filter_center_focus'" />
  <filter-drama v-else-if="valueName == 'filter_drama'" />
  <filter-frames v-else-if="valueName == 'filter_frames'" />
  <filter-hdr v-else-if="valueName == 'filter_hdr'" />
  <filter-none v-else-if="valueName == 'filter_none'" />
  <filter-tilt-shift v-else-if="valueName == 'filter_tilt_shift'" />
  <filter-vintage v-else-if="valueName == 'filter_vintage'" />
  <flare v-else-if="valueName == 'flare'" />
  <flash-auto v-else-if="valueName == 'flash_auto'" />
  <flash-off v-else-if="valueName == 'flash_off'" />
  <flash-on v-else-if="valueName == 'flash_on'" />
  <flip v-else-if="valueName == 'flip'" />
  <flip-camera-android v-else-if="valueName == 'flip_camera_android'" />
  <flip-camera-ios v-else-if="valueName == 'flip_camera_ios'" />
  <gradient v-else-if="valueName == 'gradient'" />
  <grain v-else-if="valueName == 'grain'" />
  <grid-off v-else-if="valueName == 'grid_off'" />
  <grid-on v-else-if="valueName == 'grid_on'" />
  <hdr-off v-else-if="valueName == 'hdr_off'" />
  <hdr-on v-else-if="valueName == 'hdr_on'" />
  <hdr-strong v-else-if="valueName == 'hdr_strong'" />
  <hdr-weak v-else-if="valueName == 'hdr_weak'" />
  <healing v-else-if="valueName == 'healing'" />
  <ic-image v-else-if="valueName == 'image'" />
  <image-aspect-ratio v-else-if="valueName == 'image_aspect_ratio'" />
  <image-not-supported v-else-if="valueName == 'image_not_supported'" />
  <image-search v-else-if="valueName == 'image_search'" />
  <iso v-else-if="valueName == 'iso'" />
  <landscape v-else-if="valueName == 'landscape'" />
  <leak-add v-else-if="valueName == 'leak_add'" />
  <leak-remove v-else-if="valueName == 'leak_remove'" />
  <lens v-else-if="valueName == 'lens'" />
  <linked-camera v-else-if="valueName == 'linked_camera'" />
  <looks v-else-if="valueName == 'looks'" />
  <looks-3 v-else-if="valueName == 'looks_3'" />
  <looks-4 v-else-if="valueName == 'looks_4'" />
  <looks-5 v-else-if="valueName == 'looks_5'" />
  <looks-6 v-else-if="valueName == 'looks_6'" />
  <looks-one v-else-if="valueName == 'looks_one'" />
  <looks-two v-else-if="valueName == 'looks_two'" />
  <loupe v-else-if="valueName == 'loupe'" />
  <monochrome-photos v-else-if="valueName == 'monochrome_photos'" />
  <motion-photos-on v-else-if="valueName == 'motion_photos_on'" />
  <motion-photos-pause v-else-if="valueName == 'motion_photos_pause'" />
  <motion-photos-paused v-else-if="valueName == 'motion_photos_paused'" />
  <movie-creation v-else-if="valueName == 'movie_creation'" />
  <movie-filter v-else-if="valueName == 'movie_filter'" />
  <music-note v-else-if="valueName == 'music_note'" />
  <music-off v-else-if="valueName == 'music_off'" />
  <nature v-else-if="valueName == 'nature'" />
  <nature-people v-else-if="valueName == 'nature_people'" />
  <navigate-before v-else-if="valueName == 'navigate_before'" />
  <navigate-next v-else-if="valueName == 'navigate_next'" />
  <palette v-else-if="valueName == 'palette'" />
  <panorama v-else-if="valueName == 'panorama'" />
  <panorama-fish-eye v-else-if="valueName == 'panorama_fish_eye'" />
  <panorama-horizontal v-else-if="valueName == 'panorama_horizontal'" />
  <panorama-vertical v-else-if="valueName == 'panorama_vertical'" />
  <panorama-wide-angle v-else-if="valueName == 'panorama_wide_angle'" />
  <photo v-else-if="valueName == 'photo'" />
  <photo-album v-else-if="valueName == 'photo_album'" />
  <photo-camera v-else-if="valueName == 'photo_camera'" />
  <photo-filter v-else-if="valueName == 'photo_filter'" />
  <photo-library v-else-if="valueName == 'photo_library'" />
  <photo-size-select-actual
    v-else-if="valueName == 'photo_size_select_actual'"
  />
  <photo-size-select-large v-else-if="valueName == 'photo_size_select_large'" />
  <photo-size-select-small v-else-if="valueName == 'photo_size_select_small'" />
  <picture-as-pdf v-else-if="valueName == 'picture_as_pdf'" />
  <portrait v-else-if="valueName == 'portrait'" />
  <receipt-long v-else-if="valueName == 'receipt_long'" />
  <remove-red-eye v-else-if="valueName == 'remove_red_eye'" />
  <slash-red-eye v-else-if="valueName == 'slash_red_eye'" />
  <rotate-90-degrees-ccw v-else-if="valueName == 'rotate_90_degrees_ccw'" />
  <rotate-left v-else-if="valueName == 'rotate_left'" />
  <rotate-right v-else-if="valueName == 'rotate_right'" />
  <shutter-speed v-else-if="valueName == 'shutter_speed'" />
  <slideshow v-else-if="valueName == 'slideshow'" />
  <straighten v-else-if="valueName == 'straighten'" />
  <ic-style v-else-if="valueName == 'style'" />
  <switch-camera v-else-if="valueName == 'switch_camera'" />
  <switch-video v-else-if="valueName == 'switch_video'" />
  <tag-faces v-else-if="valueName == 'tag_faces'" />
  <texture v-else-if="valueName == 'texture'" />
  <timelapse v-else-if="valueName == 'timelapse'" />
  <timer v-else-if="valueName == 'timer'" />
  <timer-3 v-else-if="valueName == 'timer_3'" />
  <timer-10 v-else-if="valueName == 'timer_10'" />
  <timer-off v-else-if="valueName == 'timer_off'" />
  <tonality v-else-if="valueName == 'tonality'" />
  <transform v-else-if="valueName == 'transform'" />
  <tune v-else-if="valueName == 'tune'" />
  <view-comfy v-else-if="valueName == 'view_comfy'" />
  <view-compact v-else-if="valueName == 'view_compact'" />
  <vignette v-else-if="valueName == 'vignette'" />
  <wb-auto v-else-if="valueName == 'wb_auto'" />
  <wb-cloudy v-else-if="valueName == 'wb_cloudy'" />
  <wb-incandescent v-else-if="valueName == 'wb_incandescent'" />
  <wb-iridescent v-else-if="valueName == 'wb_iridescent'" />
  <wb-sunny v-else-if="valueName == 'wb_sunny'" />
</template>

<script>
import AddAPhoto from "@/components/Icons/Image/AddAPhoto";
import AddPhotoAlternate from "@/components/Icons/Image/AddPhotoAlternate";
import AddToPhotos from "@/components/Icons/Image/AddToPhotos";
import Adjust from "@/components/Icons/Image/Adjust";
import Assistant from "@/components/Icons/Image/Assistant";
import AssistantPhoto from "@/components/Icons/Image/AssistantPhoto";
import Audiotrack from "@/components/Icons/Image/Audiotrack";
import Bedtime from "@/components/Icons/Image/Bedtime";
import BlurCircular from "@/components/Icons/Image/BlurCircular";
import BlurLinear from "@/components/Icons/Image/BlurLinear";
import BlurOff from "@/components/Icons/Image/BlurOff";
import BlurOn from "@/components/Icons/Image/BlurOn";
import Brightness1 from "@/components/Icons/Image/Brightness1";
import Brightness2 from "@/components/Icons/Image/Brightness2";
import Brightness3 from "@/components/Icons/Image/Brightness3";
import Brightness4 from "@/components/Icons/Image/Brightness4";
import Brightness5 from "@/components/Icons/Image/Brightness5";
import Brightness6 from "@/components/Icons/Image/Brightness6";
import Brightness7 from "@/components/Icons/Image/Brightness7";
import BrokenImage from "@/components/Icons/Image/BrokenImage";
import Brush from "@/components/Icons/Image/Brush";
import BurstMode from "@/components/Icons/Image/BurstMode";
import Camera from "@/components/Icons/Image/Camera";
import CameraAlt from "@/components/Icons/Image/CameraAlt";
import CameraFront from "@/components/Icons/Image/CameraFront";
import CameraRear from "@/components/Icons/Image/CameraRear";
import CameraRoll from "@/components/Icons/Image/CameraRoll";
import CenterFocusStrong from "@/components/Icons/Image/CenterFocusStrong";
import CenterFocusWeak from "@/components/Icons/Image/CenterFocusWeak";
import Collections from "@/components/Icons/Image/Collections";
import CollectionsBookmark from "@/components/Icons/Image/CollectionsBookmark";
import ColorLens from "@/components/Icons/Image/ColorLens";
import Colorize from "@/components/Icons/Image/Colorize";
import Compare from "@/components/Icons/Image/Compare";
import ControlPoint from "@/components/Icons/Image/ControlPoint";
import ControlPointDuplicate from "@/components/Icons/Image/ControlPointDuplicate";
import Crop from "@/components/Icons/Image/Crop";
import Crop32 from "@/components/Icons/Image/Crop32";
import Crop54 from "@/components/Icons/Image/Crop54";
import Crop75 from "@/components/Icons/Image/Crop75";
import Crop169 from "@/components/Icons/Image/Crop169";
import CropDin from "@/components/Icons/Image/CropDin";
import CropFree from "@/components/Icons/Image/CropFree";
import CropLandscape from "@/components/Icons/Image/CropLandscape";
import CropOriginal from "@/components/Icons/Image/CropOriginal";
import CropPortrait from "@/components/Icons/Image/CropPortrait";
import CropRotate from "@/components/Icons/Image/CropRotate";
import CropSquare from "@/components/Icons/Image/CropSquare";
import Dehaze from "@/components/Icons/Image/Dehaze";
import IcDetails from "@/components/Icons/Image/IcDetails";
import Edit from "@/components/Icons/Image/Edit";
import Euro from "@/components/Icons/Image/Euro";
import Exposure from "@/components/Icons/Image/Exposure";
import ExposureNeg1 from "@/components/Icons/Image/ExposureNeg1";
import ExposureNeg2 from "@/components/Icons/Image/ExposureNeg2";
import ExposurePlus1 from "@/components/Icons/Image/ExposurePlus1";
import ExposurePlus2 from "@/components/Icons/Image/ExposurePlus2";
import ExposureZero from "@/components/Icons/Image/ExposureZero";
import IcFilter from "@/components/Icons/Image/IcFilter";
import Filter1 from "@/components/Icons/Image/Filter1";
import Filter2 from "@/components/Icons/Image/Filter2";
import Filter3 from "@/components/Icons/Image/Filter3";
import Filter4 from "@/components/Icons/Image/Filter4";
import Filter5 from "@/components/Icons/Image/Filter5";
import Filter6 from "@/components/Icons/Image/Filter6";
import Filter7 from "@/components/Icons/Image/Filter7";
import Filter8 from "@/components/Icons/Image/Filter8";
import Filter9 from "@/components/Icons/Image/Filter9";
import Filter9Plus from "@/components/Icons/Image/Filter9Plus";
import FilterBAndW from "@/components/Icons/Image/FilterBAndW";
import FilterCenterFocus from "@/components/Icons/Image/FilterCenterFocus";
import FilterDrama from "@/components/Icons/Image/FilterDrama";
import FilterFrames from "@/components/Icons/Image/FilterFrames";
import FilterHdr from "@/components/Icons/Image/FilterHdr";
import FilterNone from "@/components/Icons/Image/FilterNone";
import FilterTiltShift from "@/components/Icons/Image/FilterTiltShift";
import FilterVintage from "@/components/Icons/Image/FilterVintage";
import Flare from "@/components/Icons/Image/Flare";
import FlashAuto from "@/components/Icons/Image/FlashAuto";
import FlashOff from "@/components/Icons/Image/FlashOff";
import FlashOn from "@/components/Icons/Image/FlashOn";
import Flip from "@/components/Icons/Image/Flip";
import FlipCameraAndroid from "@/components/Icons/Image/FlipCameraAndroid";
import FlipCameraIos from "@/components/Icons/Image/FlipCameraIos";
import Gradient from "@/components/Icons/Image/Gradient";
import Grain from "@/components/Icons/Image/Grain";
import GridOff from "@/components/Icons/Image/GridOff";
import GridOn from "@/components/Icons/Image/GridOn";
import HdrOff from "@/components/Icons/Image/HdrOff";
import HdrOn from "@/components/Icons/Image/HdrOn";
import HdrStrong from "@/components/Icons/Image/HdrStrong";
import HdrWeak from "@/components/Icons/Image/HdrWeak";
import Healing from "@/components/Icons/Image/Healing";
import IcImage from "@/components/Icons/Image/IcImage";
import ImageAspectRatio from "@/components/Icons/Image/ImageAspectRatio";
import ImageNotSupported from "@/components/Icons/Image/ImageNotSupported";
import ImageSearch from "@/components/Icons/Image/ImageSearch";
import Iso from "@/components/Icons/Image/Iso";
import Landscape from "@/components/Icons/Image/Landscape";
import LeakAdd from "@/components/Icons/Image/LeakAdd";
import LeakRemove from "@/components/Icons/Image/LeakRemove";
import Lens from "@/components/Icons/Image/Lens";
import LinkedCamera from "@/components/Icons/Image/LinkedCamera";
import Looks from "@/components/Icons/Image/Looks";
import Looks3 from "@/components/Icons/Image/Looks3";
import Looks4 from "@/components/Icons/Image/Looks4";
import Looks5 from "@/components/Icons/Image/Looks5";
import Looks6 from "@/components/Icons/Image/Looks6";
import LooksOne from "@/components/Icons/Image/LooksOne";
import LooksTwo from "@/components/Icons/Image/LooksTwo";
import Loupe from "@/components/Icons/Image/Loupe";
import MonochromePhotos from "@/components/Icons/Image/MonochromePhotos";
import MotionPhotosOn from "@/components/Icons/Image/MotionPhotosOn";
import MotionPhotosPause from "@/components/Icons/Image/MotionPhotosPause";
import MotionPhotosPaused from "@/components/Icons/Image/MotionPhotosPaused";
import MovieCreation from "@/components/Icons/Image/MovieCreation";
import MovieFilter from "@/components/Icons/Image/MovieFilter";
import MusicNote from "@/components/Icons/Image/MusicNote";
import MusicOff from "@/components/Icons/Image/MusicOff";
import Nature from "@/components/Icons/Image/Nature";
import NaturePeople from "@/components/Icons/Image/NaturePeople";
import NavigateBefore from "@/components/Icons/Image/NavigateBefore";
import NavigateNext from "@/components/Icons/Image/NavigateNext";
import Palette from "@/components/Icons/Image/Palette";
import Panorama from "@/components/Icons/Image/Panorama";
import PanoramaFishEye from "@/components/Icons/Image/PanoramaFishEye";
import PanoramaHorizontal from "@/components/Icons/Image/PanoramaHorizontal";
import PanoramaVertical from "@/components/Icons/Image/PanoramaVertical";
import PanoramaWideAngle from "@/components/Icons/Image/PanoramaWideAngle";
import Photo from "@/components/Icons/Image/Photo";
import PhotoAlbum from "@/components/Icons/Image/PhotoAlbum";
import PhotoCamera from "@/components/Icons/Image/PhotoCamera";
import PhotoFilter from "@/components/Icons/Image/PhotoFilter";
import PhotoLibrary from "@/components/Icons/Image/PhotoLibrary";
import PhotoSizeSelectActual from "@/components/Icons/Image/PhotoSizeSelectActual";
import PhotoSizeSelectLarge from "@/components/Icons/Image/PhotoSizeSelectLarge";
import PhotoSizeSelectSmall from "@/components/Icons/Image/PhotoSizeSelectSmall";
import PictureAsPdf from "@/components/Icons/Image/PictureAsPdf";
import Portrait from "@/components/Icons/Image/Portrait";
import ReceiptLong from "@/components/Icons/Image/ReceiptLong";
import RemoveRedEye from "@/components/Icons/Image/RemoveRedEye";
import SlashRedEye from "@/components/Icons/Image/SlashRedEye";
import Rotate90DegreesCcw from "@/components/Icons/Image/Rotate90DegreesCcw";
import RotateLeft from "@/components/Icons/Image/RotateLeft";
import RotateRight from "@/components/Icons/Image/RotateRight";
import ShutterSpeed from "@/components/Icons/Image/ShutterSpeed";
import Slideshow from "@/components/Icons/Image/Slideshow";
import Straighten from "@/components/Icons/Image/Straighten";
import IcStyle from "@/components/Icons/Image/IcStyle";
import SwitchCamera from "@/components/Icons/Image/SwitchCamera";
import SwitchVideo from "@/components/Icons/Image/SwitchVideo";
import TagFaces from "@/components/Icons/Image/TagFaces";
import Texture from "@/components/Icons/Image/Texture";
import Timelapse from "@/components/Icons/Image/Timelapse";
import Timer from "@/components/Icons/Image/Timer";
import Timer3 from "@/components/Icons/Image/Timer3";
import Timer10 from "@/components/Icons/Image/Timer10";
import TimerOff from "@/components/Icons/Image/TimerOff";
import Tonality from "@/components/Icons/Image/Tonality";
import Transform from "@/components/Icons/Image/Transform";
import Tune from "@/components/Icons/Image/Tune";
import ViewComfy from "@/components/Icons/Image/ViewComfy";
import ViewCompact from "@/components/Icons/Image/ViewCompact";
import Vignette from "@/components/Icons/Image/Vignette";
import WbAuto from "@/components/Icons/Image/WbAuto";
import WbCloudy from "@/components/Icons/Image/WbCloudy";
import WbIncandescent from "@/components/Icons/Image/WbIncandescent";
import WbIridescent from "@/components/Icons/Image/WbIridescent";
import WbSunny from "@/components/Icons/Image/WbSunny";

export default {
  components: {
    AddAPhoto,
    AddPhotoAlternate,
    AddToPhotos,
    Adjust,
    Assistant,
    AssistantPhoto,
    Audiotrack,
    Bedtime,
    BlurCircular,
    BlurLinear,
    BlurOff,
    BlurOn,
    Brightness1,
    Brightness2,
    Brightness3,
    Brightness4,
    Brightness5,
    Brightness6,
    Brightness7,
    BrokenImage,
    Brush,
    BurstMode,
    Camera,
    CameraAlt,
    CameraFront,
    CameraRear,
    CameraRoll,
    CenterFocusStrong,
    CenterFocusWeak,
    Collections,
    CollectionsBookmark,
    ColorLens,
    Colorize,
    Compare,
    ControlPoint,
    ControlPointDuplicate,
    Crop,
    Crop32,
    Crop54,
    Crop75,
    Crop169,
    CropDin,
    CropFree,
    CropLandscape,
    CropOriginal,
    CropPortrait,
    CropRotate,
    CropSquare,
    Dehaze,
    IcDetails,
    Edit,
    Euro,
    Exposure,
    ExposureNeg1,
    ExposureNeg2,
    ExposurePlus1,
    ExposurePlus2,
    ExposureZero,
    IcFilter,
    Filter1,
    Filter2,
    Filter3,
    Filter4,
    Filter5,
    Filter6,
    Filter7,
    Filter8,
    Filter9,
    Filter9Plus,
    FilterBAndW,
    FilterCenterFocus,
    FilterDrama,
    FilterFrames,
    FilterHdr,
    FilterNone,
    FilterTiltShift,
    FilterVintage,
    Flare,
    FlashAuto,
    FlashOff,
    FlashOn,
    Flip,
    FlipCameraAndroid,
    FlipCameraIos,
    Gradient,
    Grain,
    GridOff,
    GridOn,
    HdrOff,
    HdrOn,
    HdrStrong,
    HdrWeak,
    Healing,
    IcImage,
    ImageAspectRatio,
    ImageNotSupported,
    ImageSearch,
    Iso,
    Landscape,
    LeakAdd,
    LeakRemove,
    Lens,
    LinkedCamera,
    Looks,
    Looks3,
    Looks4,
    Looks5,
    Looks6,
    LooksOne,
    LooksTwo,
    Loupe,
    MonochromePhotos,
    MotionPhotosOn,
    MotionPhotosPause,
    MotionPhotosPaused,
    MovieCreation,
    MovieFilter,
    MusicNote,
    MusicOff,
    Nature,
    NaturePeople,
    NavigateBefore,
    NavigateNext,
    Palette,
    Panorama,
    PanoramaFishEye,
    PanoramaHorizontal,
    PanoramaVertical,
    PanoramaWideAngle,
    Photo,
    PhotoAlbum,
    PhotoCamera,
    PhotoFilter,
    PhotoLibrary,
    PhotoSizeSelectActual,
    PhotoSizeSelectLarge,
    PhotoSizeSelectSmall,
    PictureAsPdf,
    Portrait,
    ReceiptLong,
    RemoveRedEye,
    SlashRedEye,
    Rotate90DegreesCcw,
    RotateLeft,
    RotateRight,
    ShutterSpeed,
    Slideshow,
    Straighten,
    IcStyle,
    SwitchCamera,
    SwitchVideo,
    TagFaces,
    Texture,
    Timelapse,
    Timer,
    Timer3,
    Timer10,
    TimerOff,
    Tonality,
    Transform,
    Tune,
    ViewComfy,
    ViewCompact,
    Vignette,
    WbAuto,
    WbCloudy,
    WbIncandescent,
    WbIridescent,
    WbSunny,
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
